/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from "@azure/msal-browser";
import config from "./config/config"

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig = {
    // client
    auth: {
        clientId: `${config.azureClientId}`,
        authority: `${config.authority}`,
        redirectUri: `${config.redirectUrl}`,
        navigateToLoginRequestUrl:false
    },

    // local
    // auth: {
    //     clientId: `${config.AZURE_API_KEY}`,
    //     authority: "https://login.microsoftonline.com/872e34c0-01f1-4641-9cf1-e623ef3c49b0 ",
    //     redirectUri: `${config.REDIRECT_URL}`,
    //     // redirectUri: "https://enza-seeds.javra.com"
    // },
    cache: {
        cacheLocation: "localStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: true, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        // tokenRenewalOffsetSeconds: 300,
        loggerOptions: {
            loggerCallback: (level:any, message:any, containsPii:any) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                }
            }
        }
    }
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    scopes: [`api://${msalConfig.auth.clientId}/appaccess`]
};
export const graphloginRequest = {
    scopes: ["User.Read","Sites.Read.All"]
};


/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
};
export const imageConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me/photo/$value"
};
